import Router from 'next/router';

import api from 'api';
import type AppDispatch from 'types/AppDispatch';
import type { ReaderCourseData } from 'shared-types';

interface Params {
  chapterSlug: string;
  courseSlug: ReaderCourseData['course']['slug'];
  dispatch: AppDispatch;
  firstChapterSlug: ReaderCourseData['toc']['chapters'][number]['slug'];
}

const retryCourseCompletion = async ({
  chapterSlug,
  courseSlug,
  dispatch,
  firstChapterSlug
}: Params): Promise<boolean> => {
  const response = await api.post(
    `/reader/courses/${courseSlug}/completion-retry`
  );
  if (!response.data?.success) {
    return false;
  }

  const pageState = {
    completion: response.data.completion,
    isCompleted: false,
    ...(chapterSlug === firstChapterSlug ? { chapterForceReload: true } : {})
  };

  dispatch.updatePageState(pageState);

  if (chapterSlug !== firstChapterSlug) {
    Router.push(
      '/courses/[...courseParams]',
      `/courses/${courseSlug}/${firstChapterSlug}`
    );
  }

  return true;
};

export default retryCourseCompletion;
